import EmployeeSalaryTaxComponents from "../components/EmployeeSalaryTax";
import useEmployeeSalaryTax from "../hooks/useEmployeeSalaryTax";

function EmployeeSalaryTax() {
  const employeeSalaryTaxProps = useEmployeeSalaryTax();
  return <EmployeeSalaryTaxComponents {...employeeSalaryTaxProps} />;
}

export default EmployeeSalaryTax;
